import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/Logo-eng-web-blue.png")